import React, { Component } from "react";
// @material-ui/core components
import { withStyles } from "@material-ui/core/styles";
import withMobileDialog from "@material-ui/core/withMobileDialog";
import RecordPagination from '../../utils/RecordsPagination';

// material ui icons
import EditIcon from "@material-ui/icons/Edit";

import {
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
    TableFooter
} from "@material-ui/core";
import { appHelpers } from "../../_helpers";
import Tooltip from '@material-ui/core/Tooltip';
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import {appConstants} from "../../_constants";
// import AllDataEntryTable from "./Index";

const styles = theme => ({
    container: {
        display: "flex",
        flexWrap: "wrap"
    },
    input: {
        marginTop: "0 !important"
    },
    nb: {
        color: "red",
        fontSize: "12px"
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        width: "67%"
    },
    root: {
        flexGrow: 1
    },
    paper: {
        padding: theme.spacing.unit * 2,
        textAlign: "center",
        color: theme.palette.text.secondary
    },
    formRoot: {
        display: "flex",
        flexWrap: "wrap"
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        width: "100%"
    },
    selectEmpty: {
        marginTop: theme.spacing.unit * 2
    },
    searchButton: {
        backgroundColor: " #66bb6a"
    },
    airlineSelect: {
        marginTop: "0px",
        width: '100%'
    },
    icon: {
        margin: "8px 0px 8px 0px",
        position: "relative",
        top: "7px",
        paddingLeft: "8px",
    }
});

const CustomTableCell = withStyles(theme => ({
    head: {
        color: appConstants.REGIONAL_COLOR,
        fontSize: "14px",
        fontWeight: "lighter"
    },
    body: {
        fontSize: 14
    }
}))(TableCell);

function PdmTableStructure(props) {
    const { classes, pdmData, filterAirlines,
        openEditModal, openViewMore, user, pageIndex } = props;

    return (

        <div>
            <div className={classes.tableResponsive}
                 style={{ overflowX: "auto" }}>
                <Table className={classes.table} aria-labelledby="tableTitle">
                    <TableHead className={classes.negativeColor}>
                        <TableRow>
                            <CustomTableCell>S/No</CustomTableCell>
                            <CustomTableCell >Airline <br /> Name</CustomTableCell>
                            <CustomTableCell >Flight Number</CustomTableCell>
                            <CustomTableCell >Departure <br /> Date </CustomTableCell>
                            <CustomTableCell >Departure <br /> Location </CustomTableCell>
                            <CustomTableCell >Destination <br /> Location</CustomTableCell>
                            {/*<CustomTableCell >Passenger <br /> Count</CustomTableCell>*/}
                            {/*<CustomTableCell >Billable <br /> Passenger <br /> Count</CustomTableCell>*/}
                            {/*<CustomTableCell >Created <br /> Date</CustomTableCell>*/}
                            <CustomTableCell >Total Passengers <br/> (Auto) </CustomTableCell>
                            <CustomTableCell >Total Passengers <br/> (PDM) </CustomTableCell>
                            <CustomTableCell >Passenger Variance</CustomTableCell>
                            <CustomTableCell >Total Billable <br/> Passengers (Auto)</CustomTableCell>
                            <CustomTableCell >Total Billable <br/> Passengers (PDM)</CustomTableCell>
                            <CustomTableCell >Billable <br/> Passengers Variance (%)</CustomTableCell>
                            {/* <CustomTableCell>Service Type</CustomTableCell> */}
                            <CustomTableCell >Status</CustomTableCell>
                            {/*<CustomTableCell >Comments</CustomTableCell>*/}
                            <CustomTableCell >Actions</CustomTableCell>

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {pdmData.map((item, key) => {
                            return (
                                <TableRow hover key={key}>
                                     <TableCell >{pageIndex + key}</TableCell>
                                    <TableCell >{filterAirlines(item.AirlineId)}</TableCell>
                                    <TableCell >{item.FlightNo}</TableCell>
                                    <TableCell >{(item.DepartureDate) ? appHelpers.formatDate(item.DepartureDate, "MMM DD, YYYY") : ""}</TableCell>
                                    <TableCell >{item.DepartureLocation}</TableCell>
                                    <TableCell >{item.DestinationLocation}</TableCell>
                                    {/*<TableCell >{appHelpers.numberWithCommasOnly(item.PassengerCount)}</TableCell>*/}
                                    {/*<TableCell >{appHelpers.numberWithCommasOnly(item.BillablePassenger)}</TableCell>*/}
                                    {/*<TableCell >{(item.DateSubmitted) ? appHelpers.formatDate(item.DateSubmitted, "MMM DD, YYYY") : ""}</TableCell>*/}
                                    <TableCell >{appHelpers.numberWithCommasOnly(item.PassengerCountAuto)}</TableCell>
                                    <TableCell >{appHelpers.numberWithCommasOnly(item.PassengerCount)}</TableCell>
                                    <TableCell >{appHelpers.numberWithCommasOnly(item.PassengerVariance)}</TableCell>
                                    <TableCell >{appHelpers.numberWithCommasOnly(item.BillablePassengerCountAuto)}</TableCell>
                                    <TableCell >{appHelpers.numberWithCommasOnly(item.BillablePassengerCount)}</TableCell>
                                    <TableCell >{appHelpers.numberWithCommasOnly(item.BillablePassengerVariance)}</TableCell>
                                    {/* <TableCell>{item.ServiceTypeName}</TableCell> */}
                                    <TableCell >
                                        {item.Status === 0
                                        &&
                                        <span
                                            style={{
                                                cursor: "pointer", color: "#FF0000",
                                            }}
                                        >
                                            Pending
                                        </span>
                                        }
                                        {
                                            item.Status === 1
                                            &&
                                            <span
                                                style={{
                                                    cursor: "pointer", color: "#ffbf00",
                                                }}
                                            >
                                                    Incomplete
                                            </span>
                                        }
                                        {
                                            item.Status === 2
                                            &&
                                            <span
                                                style={{
                                                    cursor: "pointer", color: "#3c813f",
                                                }}
                                            >
                                                  Complete
                                            </span>
                                        }
                                    </TableCell>
                                    {/*<TableCell >{(item.Comments ? item.Comments : "")}</TableCell>*/}
                                    <TableCell>
                                        {item.Status === 0 && user === item.CreatedBy
                                        &&
                                        <span
                                                onClick={() => openEditModal(item)}
                                                style={{
                                                    cursor: "pointer",
                                                    color: "#ff9800",
                                                    padding: "0 5px",
                                                    float: "left"
                                                }}
                                            >
                                                <Tooltip title={"Edit"} placement="top">
                                              <span className={classes.icon}>
                                                <EditIcon/>
                                              </span>
                                                </Tooltip>

                                            </span>
                                            }
                                        {

                                        <span>
                                                 <span style={{ cursor: "pointer" }} onClick={() => openViewMore(item)}>
                                                     <Tooltip title="View" placement="top">
                                                             <span className={classes.icon}><ViewIcon /></span>
                                                         </Tooltip>
                                                 </span>
                                         </span>
                                        }
                                        {item.Status === 2
                                        &&
                                        <span>
                                            <span
                                                style={{
                                                    cursor: "pointer", backgroundColor: "#3c813f",
                                                    borderRadius: "5px", padding: "5px 10px", color: "#ffffff"
                                                }}
                                            >
                                              Complete
                                            </span>
                                        </span>
                                        }
                                    </TableCell>

                                </TableRow>
                            );
                        })}
                    </TableBody>
                    <TableFooter>
                    </TableFooter>
                </Table>

            </div >
        </div >
    );
}

class PdmTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        const { classes, fetchPdmData, totalCount, pageSize, currentPage, filterAirlines,
            filterStatus, openEditModal, pdmData,  openViewMore, user} = this.props;
        const pageIndex = (pageSize * (currentPage - 1)) + 1;
        return (
            <div>

                <RecordPagination
                    fetchMore={fetchPdmData}
                    totalCount={totalCount}
                    pageSize={pageSize}
                    currentPage={currentPage}
                    target={<PdmTableStructure
                        pageIndex={pageIndex}
                        user={user}
                        classes={classes}
                        pdmData={pdmData}
                        filterAirlines={filterAirlines}
                        filterStatus={filterStatus}
                        openEditModal={openEditModal}
                        openViewMore={openViewMore}

                    />}
                />
            </div>
        );
    }
}

export default (withMobileDialog()(withStyles(styles)(PdmTable)));



// WEBPACK FOOTER //
// ./src/Regional-Views/PDM/PdmTable.jsx